import { render, staticRenderFns } from "./DonutChart55.vue?vue&type=template&id=619fa16c&scoped=true&"
import script from "./DonutChart55.vue?vue&type=script&lang=js&"
export * from "./DonutChart55.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619fa16c",
  null
  
)

export default component.exports